module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.mode,
    attrs: {
      "id": "detail-panel"
    }
  }, [(_vm.infobit) ? _c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.infobit.title))]), _vm._v(" "), (_vm.formMode) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.titleLabel))]), _vm._v(" "), _c('text-field', {
    staticClass: "text-field",
    attrs: {
      "mode": _vm.mode,
      "model": _vm.infobit,
      "prop": "title"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.detailDefs), function(detailDef) {
    return _c('div', {
      staticClass: "field"
    }, [_c('div', {
      class: 'label ' + detailDef.label.toLowerCase()
    }, [_vm._v(_vm._s(detailDef.label))]), _vm._v(" "), _c(_vm.compName(detailDef), {
      tag: "component",
      class: _vm.compName(detailDef),
      attrs: {
        "prop": detailDef.prop,
        "mode": _vm.mode,
        "model": _vm.infobit.details
      }
    })], 1)
  }), _vm._v(" "), (_vm.infoMode) ? _c('div', {
    staticClass: "field"
  }, [_c('span', {
    staticClass: "label creator"
  }, [_vm._v(_vm._s(_vm.infobit.creator) + ",")]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.infobit.created)))])]) : _vm._e(), _vm._v(" "), _c('button', {
    class: ['submit', {
      clickable: _vm.buttonEnabled
    }],
    attrs: {
      "disabled": !_vm.buttonEnabled
    },
    on: {
      "click": _vm.buttonAction
    }
  }, [(_vm.infoMode) ? _c('span', {
    staticClass: "fa fa-fw fa-pencil"
  }) : _vm._e(), _vm._v(" "), (_vm.formMode) ? _c('span', {
    staticClass: "fa fa-fw fa-save"
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.buttonLabel) + "\n    ")]), _vm._v(" "), (_vm.infoMode) ? _c('div', {
    attrs: {
      "id": "attachments"
    }
  }, [_c('div', {
    staticClass: "label divider"
  }, [_vm._v("Files")]), _vm._v(" "), (!_vm.files) ? _c('div', {
    staticClass: "field label"
  }, [_vm._v("No files attached")]) : _c('ul', _vm._l((_vm.files), function(file) {
    return _c('li', [_c('span', {
      staticClass: "thumbnail"
    }, [(_vm.isImage(file)) ? _c('img', {
      attrs: {
        "src": _vm.imgThumbnail(file)
      }
    }) : _c('span', {
      class: _vm.fileThumbnail(file)
    })]), _vm._v(" "), _c('a', {
      staticClass: "clickable",
      attrs: {
        "href": _vm.downloadURL(file)
      }
    }, [_vm._v(_vm._s(_vm.filename(file)))])])
  }), 0), _vm._v(" "), (_vm.editable) ? _c('file-upload') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.infoMode) ? _c('div', {
    attrs: {
      "id": "context-trees"
    }
  }, [_c('div', {
    staticClass: "label divider"
  }, [_vm._v("Trees containing this infobit")]), _vm._v(" "), (!_vm.contextTrees.length) ? _c('div', {
    staticClass: "field label"
  }, [_vm._v("No trees")]) : _c('ul', _vm._l((_vm.contextTrees), function(tree) {
    return _c('li', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.showSelectedInfobitInTree(tree.uri)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.username(tree.uri)) + "\n        ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.infoMode) ? _c('div', {
    attrs: {
      "id": "backlinks"
    }
  }, [_c('div', {
    staticClass: "label divider"
  }, [_vm._v("Infobits linking to this infobit (Backlinks)")]), _vm._v(" "), (!_vm.backlinks.length) ? _c('div', {
    staticClass: "field label"
  }, [_vm._v("No Backlinks")]) : _c('ul', _vm._l((_vm.backlinks), function(link) {
    return _c('li', {
      staticClass: "clickable",
      attrs: {
        "title": "Show infobit in tree...",
        "data-infobit-id": link.id
      },
      on: {
        "click": _vm.toggleTreeSelectMenu
      }
    }, [_vm._v(_vm._s(link.value))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.visibleContextTreeSelector) ? _c('context-tree-select', {
    attrs: {
      "infobitId": _vm.treeContextSelectorSourceId,
      "entries": _vm.treeContextSelectorTrees,
      "x": _vm.treeContextSelectorPosX,
      "y": _vm.treeContextSelectorPosY
    },
    on: {
      "close": _vm.closeTreeContextSelector,
      "selection": _vm.showInfobitInTree
    }
  }) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-178bc1dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail-panel.vue
// module id = 135
// module chunks = 0